import { render, staticRenderFns } from "./CreateFormLive.vue?vue&type=template&id=f4400338"
import script from "./CreateFormLive.vue?vue&type=script&lang=js"
export * from "./CreateFormLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports